import * as React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { authActions, modal, storeFromArea } from "@mc/mc-legacy";
import { withRouter } from "react-router";
import InitPasswordPage from "./pages/InitPasswordPage";
import PasswordChangePage from "./pages/PasswordChangePage";
import "react-redux-toastr/src/styles/index.scss";
import ReduxToastr from "react-redux-toastr";
import WithAuthInfo from "./WithAuthInfo";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ProcessLoginPage from "./pages/ProcessLoginPage";
import { withLang } from "./i18n/withLang";
import { Languages } from "./i18n/Languages";
import Cookies from "js-cookie";
import {setGTM} from "./utils/GATools";

class Routes extends React.Component<any> {
  state = {
    zpravy: null,
    jazyky: null,
  };

  componentDidMount(): void {
    this.props.dispatch(authActions.fetchAuthInfoIfNeeded());
    const cookiesAccepted = Cookies.get('cookie_usage_agreement_analytics');
    if (cookiesAccepted === 'true' || cookiesAccepted === '1') {
        setGTM()
    }
  }

  componentDidUpdate(): void {
    this.props.dispatch(authActions.fetchAuthInfoIfNeeded());
      const cookiesAccepted = Cookies.get('cookie_usage_agreement_analytics');
      if (cookiesAccepted === 'true' || cookiesAccepted === '1') {
          setGTM()
      }
  }

  render() {
    return (
      <div>
        <Languages>
          <modal.ModalDialog key="modal-dialog" />
          <Switch>
            <Route path="/init-password" component={InitPasswordPage} />
            <Route path="/password-change" component={PasswordChangePage} />
            <Route path="/reset-password" component={ResetPasswordPage} />
            <Route path="/registrace" component={ProcessLoginPage} />
            <Route component={WithAuthInfo} />
          </Switch>
          <ReduxToastr />
        </Languages>
      </div>
    );
  }
}

export default withRouter(
  connect((state) => ({
    authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA),
  }))(withLang(Routes))
);
